export const gamesKeys = {
  games: "/public/games",
  demoInitGame: "/public/games/init-demo",
  initGame: "/games/init",
};
